import { TextInput } from 'react-admin';
import { required } from 'react-admin';
const noSpaces = (value: any) => {
    if (!value) return undefined;
    return /\s/.test(value) ? 'Slug must not contain spaces' : undefined;
};

const SlugInput = (props: any) => {
    return (
        <TextInput
            {...props}
            parse={v => v?.toLowerCase().replace(/\s+/g, '_') ?? ''}
            validate={[required(), noSpaces]}
        />
    );
};

export default SlugInput;
